// Cliente de la API de pre-radicación (Solicitudes de radicación / "Expedientes no
// iniciados"). Ver backend src/modules/pre-radicacion.
import { api } from './api';

export type Canal = 'CORREO' | 'FISICO' | 'SAIA' | 'OTRO';
export type DecisionComite = 'PROCEDE' | 'NO_PROCEDE' | 'SE_OMITE';
export type EstadoSolicitud = 'EN_PROCESO' | 'RADICADA' | 'NO_RADICADA';

export const CANALES: Array<{ v: Canal; label: string }> = [
  { v: 'CORREO', label: 'Correo' },
  { v: 'FISICO', label: 'Físico' },
  { v: 'SAIA', label: 'SAIA' },
  { v: 'OTRO', label: 'Otro' },
];

export const DECISIONES: Array<{ v: DecisionComite; label: string }> = [
  { v: 'PROCEDE', label: 'Procede' },
  { v: 'NO_PROCEDE', label: 'No procede' },
  { v: 'SE_OMITE', label: 'Se omite comité' },
];

export function labelCanal(v?: string | null): string {
  return CANALES.find((c) => c.v === v)?.label ?? (v ?? '—');
}
export function labelDecision(v?: string | null): string {
  return DECISIONES.find((d) => d.v === v)?.label ?? '—';
}

// Solicitud tal como la devuelve el backend (snake_case + completa/faltantes).
export interface Solicitud {
  id: string;
  fecha_ingreso: string;
  canal: Canal;
  por_ventanilla_unica: boolean;
  fecha_respuesta_ventanilla?: string | null;
  radicado_origen?: string | null;
  consecutivo_adicional?: number | null;
  radicado_completo?: string | null;
  documento_key?: string | null;
  anexo_key?: string | null;
  decision_comite?: DecisionComite | null;
  justificacion_comite?: string | null;
  comite_key?: string | null;
  fecha_decision_comite?: string | null;
  abogado_id?: string | null;
  tecnologo_apoyo_id?: string | null;
  tecnico_id?: string | null;
  director_id?: string | null;
  fecha_asignacion?: string | null;
  plazo_abogado_fecha?: string | null;
  acta_key?: string | null;
  estado_solicitud: EstadoSolicitud;
  expediente_id?: string | null;
  fecha_creacion: string;
  completa: boolean;
  faltantes: string[];
  // Nombre de quien asignó (técnico administrativo); solo en la lista de casos asignados.
  asignado_por_nombre?: string | null;
}

export interface Firmante {
  id: string;
  nombre: string;
  rol: string;
  tieneFirma: boolean;
  firmaKey?: string | null; // storage_key de la imagen de firma (para el acta)
}

export interface CrearSolicitudInput {
  fechaIngreso: string;
  canal: Canal;
  radicadoOrigen?: string;
  porVentanillaUnica?: boolean;
  documentoKey?: string;
  anexoKey?: string;
}

export interface ActualizarSolicitudInput {
  fechaIngreso?: string;
  canal?: Canal;
  radicadoOrigen?: string;
  porVentanillaUnica?: boolean;
  fechaRespuestaVentanilla?: string;
  documentoKey?: string;
  anexoKey?: string;
  decisionComite?: DecisionComite;
  justificacionComite?: string;
  comiteKey?: string;
  fechaDecisionComite?: string;
  abogadoId?: string;
  tecnologoApoyoId?: string;
  tecnicoId?: string;
  directorId?: string;
  fechaAsignacion?: string;
  plazoAbogadoFecha?: string;
}

export function listarSolicitudes(estado?: EstadoSolicitud): Promise<Solicitud[]> {
  return api<Solicitud[]>(`/solicitudes${estado ? `?estado=${estado}` : ''}`);
}
/** Casos asignados al abogado/tecnólogo de apoyo, pendientes de llenar la Etapa 2. */
export function listarAsignadas(): Promise<Solicitud[]> {
  return api<Solicitud[]>('/solicitudes/asignadas');
}
export function obtenerSolicitud(id: string): Promise<Solicitud> {
  return api<Solicitud>(`/solicitudes/${id}`);
}
export function crearSolicitud(body: CrearSolicitudInput): Promise<Solicitud> {
  return api<Solicitud>('/solicitudes', { method: 'POST', body });
}
export function actualizarSolicitud(id: string, body: ActualizarSolicitudInput): Promise<Solicitud> {
  return api<Solicitud>(`/solicitudes/${id}`, { method: 'PATCH', body });
}
export function generarActa(id: string): Promise<Solicitud> {
  return api<Solicitud>(`/solicitudes/${id}/acta`, { method: 'POST' });
}
export function radicarSolicitud(id: string, expedienteId: string): Promise<Solicitud> {
  return api<Solicitud>(`/solicitudes/${id}/radicar`, { method: 'POST', body: { expedienteId } });
}
export function listarFirmantes(): Promise<Firmante[]> {
  return api<Firmante[]>('/solicitudes/firmantes');
}
